module.exports = __webpack_public_path__ + "Roboto-BlackItalic.1f37c7545ae9f63d2279.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/roboto-fontface/fonts/roboto/Roboto-BlackItalic.svg
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BlackItalic.svg
// module chunks = styles